// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function aacClear(): ReducerAction {
	return {
		type: Types.AAC_CLEAR,
		payload: null,
	};
}
